import { formatDistanceToNow } from "date-fns";
import { he } from "date-fns/locale";

export const fromNow = (timestamp: number) => {
    if(!timestamp) return "n/a";
    return formatDistanceToNow(new Date(timestamp), { addSuffix: true, locale: he }).replace("מספר", "כמה");
};